import React, {useEffect, useState} from "react";
import {Col, Row, Card, Button, Icon} from "antd";
import {FormattedMessage} from "react-intl";
import paymentReportApi from '@api/payment-report'
import PurchasesReportSearch from '@components/payments/types/Search';
import ReportsChart from '@components/payments/types/Chart';
import ReportList from '@components/payments/types/List';
import whitListData from "../../hocs/withListData";
import withPaginationComponent from "../../hocs/withPaginationComponent";
import {useSelector} from "react-redux";
import {getMainClientId} from "../../components/clients/selectors";




function useListFilter() {
  const client_id = useSelector(getMainClientId);
  return {
    client_id,
  }
}

function PaymentsReportTypesPage(props) {
  const { data, isFetched} = props;
  
  return (
    <Row gutter={16}>
      <Col span={24}>
        {data.length > 0 && <ReportsChart data={data}/>}
        
        <ReportList
          loading={!isFetched}
          data={data}/>
      </Col>
    </Row>
  )
}



export default whitListData(
  withPaginationComponent(PaymentsReportTypesPage),
  {
    fetchRequest: paymentReportApi.getTypes,
    paginationOnScroll: false,
    useFilter: useListFilter
  }
);

